/**
 * A util function to filter out the Unified Nav Bar based on feature flag enablement
 *
 * @function
 *
 * @param subMenuItem {String} key/id for a submenu item listing of a nav submenu
 * @param featureFlags {Object} an object for reading customer feature flags booleans
 */
const filterUnifiedNavSubmenuView = (subMenuItem, featureFlags) => {
  const { isEmergencyRolesUser } = featureFlags;
  if (subMenuItem.id === 'emergency-access') {
    if (!isEmergencyRolesUser) {
      subMenuItem.subMenu = subMenuItem.subMenu.filter(
        (ele) => ele.id !== 'request-emergency-access-roles'
      );
    }
  }
};

export default filterUnifiedNavSubmenuView;
